import {create} from "zustand";


type Store = {
    isAuthenticated: boolean;
    setAuthenticated: (isAuthenticated: boolean) => void;
}

export const useAuthenticationStore = create<Store>((set) => ({
    isAuthenticated: false,
    setAuthenticated: (isAuthenticated: boolean) => set({isAuthenticated}),
}));


